export default __webpack_public_path__ + "static/media/349D.01bcc8ad.pdf";